/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Text, theme } from "@nordcloud/gnui";
import { useCloudResource } from "~/views/resources_v2/ResourceProvider";
import { ResourceScheduleCalendar } from "~/views/timeline/components";

export function ScheduleTab() {
  const { cloudResource } = useCloudResource();

  return (
    <div data-testid="resource-schedule-tab">
      <Text mb={0}>Schedule</Text>
      <Text size="sm" color={theme.color.text.text02}>
        Calendar view of past and upcoming actions scheduled for this resource.
        Past actions appear faded.
      </Text>
      <ResourceScheduleCalendar resourceId={cloudResource?.id ?? ""} />
    </div>
  );
}
